import api from './api';

export interface Session {
  id: number;
  training_id: number;
  session_date: string;
    training: {
      id: number;
      title: string;
      banner_image?: string;
      country?: string;
      city?: string;
      format?: string;
      duration?: string;
      pricing_dzd?: number;
      trainer?: string;
      language?: string;
      level?: string;
      short_description?: string;
      full_description?: string;
      domaine?: {
        id: number;
        name_french: string;
        name_english: string;
      };
      subcategory?: {
        id: number;
        name_french: string;
        name_english: string;
      };
      training_center: {
        id: number;
        name: string;
        logo?: string;
      };
    };
}

export interface CreateSessionData {
  training_id: number;
  session_date: string;
}

class SessionsService {
  async getAllSessions(): Promise<Session[]> {
    const url = '/public/sessions';
    const response = await api.get(url);
    return response.data;
  }

  async getSessionsByTrainingCenter(trainingCenterId: number): Promise<Session[]> {
    const response = await api.get(`/sessions/training-center/${trainingCenterId}`);
    return response.data;
  }

  async getSessionsByDateRange(startDate: string, endDate: string): Promise<Session[]> {
    const response = await api.get(`/sessions/date-range?startDate=${startDate}&endDate=${endDate}`);
    return response.data;
  }

  async getSession(id: number): Promise<Session> {
    const response = await api.get(`/sessions/${id}`);
    return response.data;
  }

  async createSession(data: CreateSessionData): Promise<Session> {
    const response = await api.post('/sessions', data);
    return response.data;
  }

  async updateSession(id: number, data: Partial<CreateSessionData>): Promise<Session> {
    const response = await api.patch(`/sessions/${id}`, data);
    return response.data;
  }

  async deleteSession(id: number): Promise<void> {
    await api.delete(`/sessions/${id}`);
  }
}

const sessionsService = new SessionsService();
export default sessionsService;
